import type { CardInstance, CardLookup } from "../types/index.js";

export type WorkerHealInput = {
  hand: readonly CardInstance[];
  lookup: CardLookup;
};

export function workerHeal(input: WorkerHealInput): number {
  let sum = 0;

  for (const card of input.hand) {
    const definition = input.lookup(card.cardId);
    if (definition?.type === "worker" && definition.heal) {
      sum += definition.heal;
    }
  }

  return sum;
}
